import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Mutation, MutationUnregisterMobileDeviceByIdArgs } from 'graphql/generated/graphqlTypes';
import { UNREGISTER_MOBILE_DEVICE_BY_ID } from 'graphql/v2/mutations';
import { BaseHookProps } from 'hooks/shared/types';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const UNREGISTER_MOBILE_DEVICE_BY_ID_TYPED: TypedDocumentNode<
  Pick<Mutation, 'unregisterMobileDeviceById'>,
  MutationUnregisterMobileDeviceByIdArgs
> = UNREGISTER_MOBILE_DEVICE_BY_ID;

const useUnregisterMobileDevice = ({ handleFetchError }: BaseHookProps) => {
  const [unregisterMobileDeviceByIdMutation, { loading: unregisterMobileDeviceByIdMutationLoading }] = useMutation(
    UNREGISTER_MOBILE_DEVICE_BY_ID_TYPED,
    {
      onError: () => handleFetchError('Error while unregister Mobile Device')
    }
  );

  const unregisterMobileDeviceById = async (visitorId: string, mobileDeviceId: string) => {
    const { data } = await ignoreHandledMutationError(
      unregisterMobileDeviceByIdMutation({
        variables: {
          visitorId,
          mobileDeviceId
        }
      })
    );

    return data;
  };

  return {
    unregisterMobileDeviceById,
    unregisterMobileDeviceByIdMutationLoading
  };
};

export default useUnregisterMobileDevice;
